import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_NATIVE_SHARE_TITLE = defineFcm('native_share_title')
	.asJson(
		z.object({
			enabled: z.boolean().optional(),
			experimentName: z.string().optional(),
			// The share `context` each native share button tracks with; Admin rejects a name that isn't listed.
			surfaces: z
				.array(
					z.enum([
						'petition_show_image',
						'petition_show_sign_cta_inline',
						'petition_show_sign_cta_sticky',
						'petition_show',
						'psf_promote_or_share',
						'psf_combo_share_initial',
						'psf_combo_share_message',
					]),
				)
				.optional(),
		}),
	)
	.withDefault({ enabled: false, experimentName: undefined, surfaces: [] })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Mobile native share (petition page, PSF slide-up, PSF share page)',
		description: `Gates the native share title experiment, which adds a title to the mobile native share sheet.
			surfaces lists the share contexts that take part (e.g. psf_promote_or_share); a native share button whose
			context is not listed keeps sharing the bare URL and never enrolls the user, so a surface can be added or
			dropped here without a deploy. To switch the experiment off, set enabled: false rather than using Disable.`,
		supportedGroups: { global: true, locales: true, countries: true },
		template: {
			enabled: true,
			experimentName: 'native_share_title_experiment',
			surfaces: ['psf_promote_or_share'],
		},
	});
